(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

(function ($) {

    $(document).ready(function () {
        // add/remove checked class
        $(".image-radio-style").each(function () {
            if ($(this).find('input[type="radio"]').first().attr("checked")) {
                $(this).addClass('checked');
            } else {
                $(this).removeClass('checked');
            }
        });

        // sync the input state
        $(".image-radio-style").on("click", function (e) {
            $(".image-radio-style").removeClass('checked');
            $(this).addClass('checked');
            var $radio = $(this).find('input[type="radio"]');
            $radio.prop("checked", !$radio.prop("checked"));

            e.preventDefault();
        });

        // add/remove checked class
        $(".keen-radio-positionlink").each(function () {
            if ($(this).find('input[type="radio"]').first().attr("checked")) {
                $(this).addClass('checked');
            } else {
                $(this).removeClass('checked');
            }
        });

        // sync the input state
        $(".keen-radio-positionlink").on("click", function (e) {
            $(".keen-radio-positionlink").removeClass('checked');
            $(this).addClass('checked');
            var $radio = $(this).find('input[type="radio"]');
            $radio.prop("checked", !$radio.prop("checked"));

            e.preventDefault();
        });

        $.fn.multiselect = function () {
            $(this).each(function () {
                var checkboxes = $(this).find("input:checkbox");
                checkboxes.each(function () {
                    var checkbox = $(this);
                    // Highlight pre-selected checkboxes
                    if (checkbox.prop("checked")) checkbox.parent().addClass("multiselect-on");

                    // Highlight checkboxes that the user selects
                    checkbox.click(function () {
                        if (checkbox.prop("checked")) checkbox.parent().addClass("multiselect-on");else checkbox.parent().removeClass("multiselect-on");
                    });
                });
            });
        };

        $(".keen-radio").multiselect();
    });
})(jQuery);

},{}]},{},[1]);
